module.exports = __webpack_public_path__ + "img/lisata.f8616450.png";